export default "__VITE_ASSET__CEdwxrrT__"